import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../views/MainHomePages/LoginPage.vue";

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/LandingPage",
    name: "LandingPage",
    component: () => import("../views/MainHomePages/LandingPage.vue"),
    children: [
      {
        path: "/Dashboard",
        name: "Dashboard",
        component: () => import("../views/ChildrenHomePages/Dashboard.vue"),
      },
      {
        path: "/LawEnforcement",
        name: "Law Enforcement",
        component: () =>
          import("../views/ChildrenHomePages/LawEnforcement.vue"),
      },
      {
        path: "/MotoristPage",
        name: "Motorist",
        component: () => import("../views/ChildrenHomePages/MotoristPage.vue"),
      },
      {
        path: "/Supervisors",
        name: "Supervisors",
        component: () => import("../views/ChildrenHomePages/Supervisors.vue"),
      },
      {
        path: "/AdminUsers",
        name: "Admin Users",
        component: () => import("../views/ChildrenHomePages/AdminUsers.vue"),
      },
      {
        path: "/ViolationsPage",
        name: "Violations",
        component: () =>
          import("../views/ChildrenHomePages/ViolationsPage.vue"),
      },
      {
        path: "/Stations",
        name: "Stations",
        component: () => import("../views/ChildrenHomePages/StationsPage.vue"),
      },
      {
        path: "/County",
        name: "County",
        component: () => import("../views/ChildrenHomePages/County.vue"),
      },
      {
        path: "/City",
        name: "City",
        component: () => import("../views/ChildrenHomePages/City.vue"),
      },
      {
        path: "/ViolationsPage",
        name: "Violations",
        component: () =>
          import("../views/ChildrenHomePages/ViolationsPage.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
